import { Component } from '@angular/core';
import { Logger } from '@shared/common/logger';
import { DiscountService } from '@studiobuki/web-core/lib/discount';
import { getDiscount } from '@shared/jp/discount/utils';
import { MediaService } from '@studiobuki/web-core/lib/media';
import { faqDataCondensed } from 'src/app/data/faq/data';
import { Router } from '@angular/router';
import { stepsData } from 'src/app/data/steps/data';
import { ROUTE_PATH_FAQ } from '@studiobuki/web-core/lib/routing';
import type { TFeaturesData } from '@studiobuki/web-core/lib/section-features';
import Books from 'src/app/data/books';
import { descriptionData } from 'src/app/data/description/description';
import { ViewportScroller } from '@angular/common';
import LetsMakeMetro from '../../data/books/LetsMakeMetro';
import { BookLetsMakeMetroService } from '../book-page/pages/book-lets-make-metro-page/book-lets-make-metro.service';

const log = new Logger('HomePageComponent');

@Component({
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent {
  public readonly book = LetsMakeMetro;

  public readonly books = Books;

  public readonly getBooksDiscount = getDiscount;

  public readonly descriptionData = descriptionData;

  public readonly featuresData: TFeaturesData = [
    {
      imgSrc: 'assets/images/feature1.png',
      text: ['世界に一冊の', '特別な絵本'],
    },
    {
      imgSrc: 'assets/images/feature2.png',
      text: ['送料 ¥420 (メール便)', '¥780～ (宅急便)'],
    },
    {
      imgSrc: 'assets/images/feature3.png',
      text: ['環境に配慮した素材を使用'],
    },
    {
      imgSrc: 'assets/images/feature4.png',
      text: ['お祝いやお誕生日の', 'プレゼントに'],
    },
  ];

  public readonly faqDataCondensed = faqDataCondensed;

  public readonly sectionSteps = stepsData;

  public loading = false;

  constructor(
    public discountService: DiscountService,
    public mediaService: MediaService,
    private _bookLetsMakeMetroService: BookLetsMakeMetroService,
    private _router: Router,
    private viewportScroller: ViewportScroller,
  ) {}

  public onFaqButtonClick() {
    log.info('onFaqButtonClick');
    return this._router.navigate([ROUTE_PATH_FAQ]);
  }

  public scrollToBooks() {
    this.viewportScroller.scrollToAnchor('preform');
  }
}
